import { FlossPalette, Text, styled } from '@orthly/ui-primitives';
import React from 'react';

const Card = styled('div')({
    background: FlossPalette.TAN,
    border: `1px solid ${FlossPalette.STROKE_LIGHT}`,
    borderRadius: '12px',
    padding: '20px',
});

export const PatientDetailCard: React.VFC<{
    title?: string;
    gridArea: 'patient' | 'treatment' | 'scans';
    children: React.ReactNode;
}> = ({ title, gridArea, children }) => {
    return (
        <Card style={{ gridArea }}>
            {title && (
                <Text variant={'body2'} medium color={'DARK_GRAY'}>
                    {title}
                </Text>
            )}

            {children}
        </Card>
    );
};
